import script from "./PreloaderBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PreloaderBar.vue?vue&type=script&setup=true&lang=js"

import "./PreloaderBar.vue?vue&type=style&index=0&id=70ad9af3&lang=scss"

const __exports__ = script;

export default __exports__